import { HelperResult } from '@openclassrooms/sdk-web/src';
import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

interface CommunicationSetting {
  type: string;
  value: boolean;
}

interface CommunicationSettingResponse extends CommunicationSetting {
  updatedAt: string;
}

interface UpdateBody {
  communicationSettings: CommunicationSetting[];
}

const { useUpdate: useUpdateCommunicationSettings, useFind: useCommunicationSettings } =
  getCRUDHooks({
    entityName: 'UserCommunicationSettings',
    update: (
      { communicationSettings }: UpdateBody,
      { userId, context }: { userId: number; context: string }
    ): HelperResult<CommunicationSettingResponse> =>
      clientApi
        .getOCClient()
        .helpers.user.users.partialUpdateCommunicationSettings(userId, communicationSettings, {
          context,
        }),
    find: ({ userId }: { userId: number }): HelperResult<CommunicationSettingResponse[]> =>
      clientApi.getOCClient().helpers.user.users.getCommunicationSettings(userId),
  });

export { useUpdateCommunicationSettings, useCommunicationSettings };
